export const AUTH_LOGIN = 'AUTH_LOGIN';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';
export const UPDATE_REFRESH_TOKEN = 'UPDATE_REFRESH_TOKEN';
export const VERIFY_TOKEN = 'VERIFY_TOKEN';
export const UPDATE_TIMEZONE = 'UPDATE_TIMEZONE';
